import { useSession } from '@airship-platform/airship-auth';
import {
  BarChartIcon,
  CalendarIcon,
  GearIcon,
  HomeNavIcon,
  TemplateIcon,
} from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

interface NavItem {
  title: string;
  icon: React.ReactNode;
  path: string;
  lookupPath?: string;
}

const isCurrentPath = (path: string, lookupPath?: string): boolean =>
  lookupPath
    ? window.location.pathname.startsWith(lookupPath)
    : window.location.pathname === path;

const NavBarBody: React.FC = () => {
  const { claims } = useSession();
  const isOwner = ['OWNER', 'AIRSHIP_ADMIN'].includes(claims?.userRole || '');

  const navItems: NavItem[] = [
    isOwner && [
      {
        title: 'Home',
        icon: <HomeNavIcon />,
        path: '/organizations/',
      },
    ],
    {
      title: 'Schedules',
      icon: <CalendarIcon />,
      path: '/service-management/',
      lookupPath: '/service-management',
    },
    {
      title: 'Insights',
      icon: <BarChartIcon />,
      path: '/proposal-insights/',
      lookupPath: '/proposal-insights',
    },
    isOwner && [
      {
        title: 'Templates',
        icon: <TemplateIcon />,
        path: '/proposal-templates/',
        lookupPath: '/proposal-templates',
      },
      {
        title: 'Settings',
        icon: <GearIcon />,
        path: '/organizations/settings/',
        lookupPath: '/organizations',
      },
    ],
  ].flatMap((d) => d || []);

  return (
    <>
      {navItems.map((item) => (
        <ListItem key={item.path} disableGutters>
          <Button
            color={
              isCurrentPath(item.path, item.lookupPath) ? 'gold' : 'softGold'
            }
            LinkComponent={Link}
            href={item.path}
            startIcon={item.icon}
            size="large"
            fullWidth
            sx={{ justifyContent: 'flex-start' }}
          >
            <Typography
              component={'span'}
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
              variant="inherit"
            >
              {item.title}
            </Typography>
          </Button>
        </ListItem>
      ))}
    </>
  );
};

export default NavBarBody;
